var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cardClass,on:{"click":function($event){return _vm.$emit('change')}}},[_c('a-space',{attrs:{"size":39}},[_c('service-count-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}}),_c('a-statistic',{staticStyle:{"color":"#fff","margin-right":"24px"},attrs:{"title":_vm.title,"value":_vm.count,"valueStyle":{
        color: '#fff',
        fontSize: '32px',
        fontWeight: 500,
        lineHeight: '45px'
      }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }